"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const useClickOutsideHandler_1 = __importDefault(require("~/hooks/useClickOutsideHandler"));
const useIsomorphicLayoutEffect_1 = __importDefault(require("~/hooks/useIsomorphicLayoutEffect"));
const UI_1 = require("~/components/UI");
const DropdownMenuItems_1 = __importDefault(require("./DropdownMenuItems"));
function DropdownMenu({ items, children, onVisibilityChange, closeParent, isRoot = false, showOn = 'click', }) {
    const [top, setTop] = (0, react_1.useState)(0);
    const [left, setLeft] = (0, react_1.useState)(0);
    const [childrenRef, setChildrenRef] = (0, react_1.useState)(null);
    const [menuRef, setMenuRef] = (0, react_1.useState)(null);
    const menuWrapperRef = (0, react_1.useRef)(null);
    const childrenWrapperRef = (0, react_1.useRef)(null);
    const [expanded, setExpanded] = (0, react_1.useState)(false);
    const [hideTimeout, setHideTimeout] = (0, react_1.useState)(-1);
    const onClick = () => setExpanded(!expanded);
    const onMouseEnter = () => {
        if (hideTimeout !== -1) {
            window.clearTimeout(hideTimeout);
        }
        setHideTimeout(window.setTimeout(() => setExpanded(true), 400));
    };
    const onMouseLeave = () => {
        if (hideTimeout !== -1) {
            window.clearTimeout(hideTimeout);
        }
        setHideTimeout(window.setTimeout(() => setExpanded(false), 400));
    };
    // cleanup for cases when user closes menu by clicking outside but there is unfinished timeout
    (0, react_1.useEffect)(() => {
        return () => {
            window.clearTimeout(hideTimeout);
        };
    });
    // run before paint so the menu never flashes at its default (0, 0) position
    (0, useIsomorphicLayoutEffect_1.default)(() => {
        if (!childrenRef || !menuRef) {
            return;
        }
        const childrenRect = childrenRef.getBoundingClientRect();
        if (isRoot) {
            setTop(childrenRect.top + childrenRect.height);
            setLeft(childrenRect.left);
        }
        else {
            setTop(0);
            setLeft(childrenRect.width);
        }
    }, [childrenRef, menuRef, isRoot]);
    (0, react_1.useEffect)(() => {
        onVisibilityChange === null || onVisibilityChange === void 0 ? void 0 : onVisibilityChange(expanded);
    }, [expanded, onVisibilityChange]);
    const style = (0, react_1.useMemo)(() => {
        return {
            position: 'absolute',
            transform: `translate(${left}px, ${top}px)`,
            pointerEvents: 'all',
        };
    }, [top, left]);
    const childrenWithRef = react_1.default.Children.map(children, (child) => {
        if ((0, react_1.isValidElement)(child) && 'ref' in child) {
            return (0, react_1.cloneElement)(child, {
                onClick,
                ref: (ref) => setChildrenRef(ref),
            });
        }
        return child;
    });
    const closeMenu = () => {
        setExpanded(false);
        closeParent === null || closeParent === void 0 ? void 0 : closeParent();
    };
    (0, useClickOutsideHandler_1.default)(childrenWrapperRef, menuWrapperRef, closeMenu);
    return (react_1.default.createElement("div", { onMouseEnter: showOn === 'hover' && !isRoot ? onMouseEnter : undefined, onMouseLeave: showOn === 'hover' && !isRoot ? onMouseLeave : undefined },
        expanded &&
            (isRoot ? (react_1.default.createElement(UI_1.Portal, null,
                react_1.default.createElement("div", { ref: menuWrapperRef },
                    react_1.default.createElement("div", { style: style, ref: (ref) => setMenuRef(ref) },
                        react_1.default.createElement(DropdownMenuItems_1.default, { items: items, closeMenu: closeMenu }))))) : (react_1.default.createElement("div", { style: style, ref: (ref) => setMenuRef(ref) },
                react_1.default.createElement(DropdownMenuItems_1.default, { items: items, closeMenu: closeMenu })))),
        react_1.default.createElement("div", { ref: childrenWrapperRef }, childrenWithRef)));
}
exports.default = DropdownMenu;
